"use strict";

import {init} from "@elements/alert-notification";

init({
    // default options
});
